// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-buyer-text {
  font-size: 23px;
  font-weight: 700;
  font-family: "Montserrat";
}
.review-buyer-text-cont {
  height: 65px;
  display: flex;
  align-items: center;
}
.terms-requestpage {
  padding-inline: 4.46rem;
}
.terms-card-container {
  height: 66vh;
  overflow: auto;
  width: 100%;
}
.terms-requestpage .ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 0px;
}
.terms-segment {
  padding: 20px 0;
  margin-left: -1% !important;
}
.request-segments {
  color: #000;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 51px;

  width: 100%;
  max-width: 800px;
  min-width: 400px;

  overflow-x: auto;
  white-space: nowrap;
}
@media (max-width: 1024px) {
  .terms-requestpage {
    padding-inline: 2.46rem;
  }
}

@media (min-width: 370px) and (max-width: 435px) {
  .terms-segment {
    padding: 10px 0;
    margin-left: 0px;
    width: 100%;
    overflow: scroll;
  }

  .request-segments .ant-segmented.ant-segmented-sm .ant-segmented-item-label {
    min-height: 20px;
    line-height: 20px;
    width: 100% !important;
    padding: 0 7px;
  }

  .request-segments {
    color: #000;
    font-size: var(--Font-Font-Size-p, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    height: 51px;
    width: 300px;
    overflow-x: scroll;
  }

  .terms-requestpage {
    padding-inline: 1.15rem;
  }
}
@media (max-width: 369px) {
  .terms-segment {
    padding: 10px 0;
    margin-left: 0px;
    width: 300px;
    overflow: scroll;
  }
  .terms-requestpage {
    padding-inline: 1.46rem;
  }
  .review-buyer-text-cont {
    height: 70px;
    display: flex;
    align-items: center;
  }
  .review-buyer-text {
    font-size: 19px;
    font-weight: 700;
    font-family: "Montserrat";
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/terms-requests/TermsRequestPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;;EAEZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;EAEhB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;AACF","sourcesContent":[".review-buyer-text {\n  font-size: 23px;\n  font-weight: 700;\n  font-family: \"Montserrat\";\n}\n.review-buyer-text-cont {\n  height: 65px;\n  display: flex;\n  align-items: center;\n}\n.terms-requestpage {\n  padding-inline: 4.46rem;\n}\n.terms-card-container {\n  height: 66vh;\n  overflow: auto;\n  width: 100%;\n}\n.terms-requestpage .ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 0px;\n}\n.terms-segment {\n  padding: 20px 0;\n  margin-left: -1% !important;\n}\n.request-segments {\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  height: 51px;\n\n  width: 100%;\n  max-width: 800px;\n  min-width: 400px;\n\n  overflow-x: auto;\n  white-space: nowrap;\n}\n@media (max-width: 1024px) {\n  .terms-requestpage {\n    padding-inline: 2.46rem;\n  }\n}\n\n@media (min-width: 370px) and (max-width: 435px) {\n  .terms-segment {\n    padding: 10px 0;\n    margin-left: 0px;\n    width: 100%;\n    overflow: scroll;\n  }\n\n  .request-segments .ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n    min-height: 20px;\n    line-height: 20px;\n    width: 100% !important;\n    padding: 0 7px;\n  }\n\n  .request-segments {\n    color: #000;\n    font-size: var(--Font-Font-Size-p, 16px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    height: 51px;\n    width: 300px;\n    overflow-x: scroll;\n  }\n\n  .terms-requestpage {\n    padding-inline: 1.15rem;\n  }\n}\n@media (max-width: 369px) {\n  .terms-segment {\n    padding: 10px 0;\n    margin-left: 0px;\n    width: 300px;\n    overflow: scroll;\n  }\n  .terms-requestpage {\n    padding-inline: 1.46rem;\n  }\n  .review-buyer-text-cont {\n    height: 70px;\n    display: flex;\n    align-items: center;\n  }\n  .review-buyer-text {\n    font-size: 19px;\n    font-weight: 700;\n    font-family: \"Montserrat\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
